import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { Directory } from "./pages/Directory";
import { Profile } from "./pages/Profile";
import { ReviewNew } from "./pages/ReviewNew";
import { Methodology } from "./pages/Methodology";
import { Privacy } from "./pages/Privacy";
import { About } from "./pages/About";
import { Compare } from "./pages/Compare";
import { Admin } from "./pages/Admin";
import { Dashboard, Listings } from "./pages/dashboard/Dashboard";
import { Submit } from "./pages/dashboard/Submit";
import { AdminShell } from "./pages/admin/AdminShell";
import { Listings as AdminListings } from "./pages/admin/Listings";
import { Pricing as AdminPricing } from "./pages/admin/Pricing";
import { Claim } from "./pages/dashboard/Claim";
import { Team } from "./pages/dashboard/Team";
import { Developer } from "./pages/dashboard/Developer";
import { Reviews as DashReviews } from "./pages/dashboard/Reviews";
import { Analytics } from "./pages/dashboard/Analytics";
import { NotFound, Login } from "./pages/Misc";
import { Reviewer } from "./pages/Reviewer";

/** The route table, router-agnostic so the server can wrap it in StaticRouter. */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="tokens" element={<Directory type="token" />} />
        <Route path="companies" element={<Directory type="company" />} />
        <Route path="category/:slug" element={<Directory />} />
        <Route path="token/:slug" element={<Profile type="token" />} />
        <Route path="company/:slug" element={<Profile type="company" />} />
        <Route path="review/new/:entityId" element={<ReviewNew />} />
        <Route path="compare" element={<Compare />} />
        <Route path="methodology" element={<Methodology />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="about" element={<About />} />
        <Route path="admin" element={<AdminShell />}>
          <Route index element={<Admin />} />
          <Route path="listings" element={<AdminListings />} />
          <Route path="pricing" element={<AdminPricing />} />
        </Route>
        <Route path="dashboard" element={<Dashboard />}>
          <Route index element={<Listings />} />
          <Route path="submit" element={<Submit />} />
          <Route path="claim" element={<Claim />} />
          <Route path="team" element={<Team />} />
          <Route path="reviews" element={<DashReviews />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="developer" element={<Developer />} />
        </Route>
        <Route path="u/:username" element={<Reviewer />} />
        <Route path="login" element={<Login />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
